import React from 'react';

import {dataChangesPublisher} from 'app/demo/demo_fixtures';
import {withProcedureEditPageShortcuts} from 'app/procedures/components/ProcedureEditPage/LoadableProcedureEditPage';
import ProcedureEditPage, {
  type WithShortcutOwnProps,
} from 'app/procedures/components/ProcedureEditPage/ProcedureEditPage';
import {
  LoadByHashidInjectedProps,
  loadProcedureByHashid,
  loadProcedureVersionByVersionId,
  LoadVersionsInjectedProps,
} from 'app/procedures/hocs';

import {
  ProcedureSerializedType,
  ProcedureVersionSerializedType,
} from 'sweet-types';

const PreparedProcedureEditPage =
  withProcedureEditPageShortcuts(ProcedureEditPage);

interface Props
  extends WithShortcutOwnProps,
    LoadByHashidInjectedProps<ProcedureSerializedType>,
    LoadVersionsInjectedProps<ProcedureVersionSerializedType, unknown, true> {}

function BaseDemoProcedureEditPage({fetchedByHashid, ...other}: Props) {
  React.useEffect(() => {
    const {fetchObject} = fetchedByHashid;

    const subscription = dataChangesPublisher.subscribe(
      'procedure',
      fetchObject
    );

    return subscription.remove;
  }, []);

  return <PreparedProcedureEditPage {...other} />;
}

export const DemoProcedureEditPage = loadProcedureByHashid(
  loadProcedureVersionByVersionId(BaseDemoProcedureEditPage)
);
